const detectSoldOutItemsInCartFun = (
  currentOrder,
  menuItems,
  soldOutItems = []
) => {
  let isSoldOutPresent = false;
  // let items = [];

  soldOutItems.forEach(({ menuItemId, smId, variantId }) => {
    currentOrder?.menuItems?.forEach(({ _id, itemType, ...item }) => {
      if (menuItemId === _id) {
        if (itemType === 0) {
          const { selectedSizes } = item;

          if (
            selectedSizes.some(
              ({ _id, variants }) =>
                _id === smId && variants.some(({ _id }) => _id === variantId)
            )
          ) {
            isSoldOutPresent = true;
          }
        } else if (itemType === 1) {
          const { selectedModifiers } = item;

          if (selectedModifiers.some(({ _id }) => _id === smId)) {
            isSoldOutPresent = true;
          }
        }
      }
    });
  });

  return isSoldOutPresent;

  /* if (currentOrder.menuItems) {
    currentOrder.menuItems.forEach((item) => {
      let matchingItems = menuItems.filter((m) => {
        return m._id === item._id;
      });
      if (matchingItems.length > 0 && soldOutItems) {
        let matchedItem = matchingItems[0];
        let menuItemSoldOut = soldOutItems.filter((soldOutItem) => {
          return soldOutItem.menuItemId === matchedItem._id;
        });
        let count = 0;
        if (item.itemType === 0) {
          item.selectedSizes.map((s) => {
            let matchingSizes = matchedItem.selectedSizes.filter((o) => {
              return o._id === s._id;
            });
            if (matchingSizes.length > 0) {
              let matchedSize = matchingSizes[0];
              menuItemSoldOut.forEach((soldOutSize) => {
                if (soldOutSize.smId === matchedSize._id) {
                  count = count + 1;
                }
              });
              //if (!matchedSize.isAvailable) count = count + 1;
              if (
                s.variants &&
                s.variants.length > 0 &&
                matchedItem.variants &&
                matchedItem.variants.length > 0
              ) {
                s.variants.map((v) => {
                  if (v.quantity > 0) {
                    let matchingVs = matchedItem.variants.map((vv) => {
                      return v._id === vv.id;
                    });
                    if (matchingVs.length > 0) {
                      let matchingV = matchingVs[0];
                      menuItemSoldOut.forEach((soldOutSize) => {
                        if (
                          soldOutSize.smId === matchedSize._id &&
                          soldOutSize.variantId === matchingV._id
                        ) {
                          count = count + 1;
                        }
                      });
                      //if (!matchingV.isAvailable) count = count + 1;
                    }
                  }
                  return v;
                });
              }
            }
            return s;
          });
        } else if (item.itemType === 1) {
          item.selectedModifiers.forEach((modifier) => {
            modifier.subModifiers.forEach((subModifier) => {
              menuItemSoldOut.forEach((soldOutSubModifier) => {
                if (
                  soldOutSubModifier.smId === subModifier._id &&
                  soldOutSubModifier.variantId === null
                ) {
                  count++;
                }
                if (
                  soldOutSubModifier.smId === subModifier._id &&
                  soldOutSubModifier.variantId !== null
                ) {
                  if (subModifier.variants) {
                    subModifier.variants.forEach((variant) => {
                      if (
                        soldOutSubModifier.smId === subModifier._id &&
                        soldOutSubModifier.variantId === variant._id
                      ) {
                        count++;
                      }
                    });
                  }
                }
              });
            });
          });
        }

        if (count !== 0) items.push(matchedItem);
      }
    });
    if (items.length > 0) isSoldOutPresent = true;
  }
  return isSoldOutPresent; */
};

export const detectSoldOutItemsInCart = detectSoldOutItemsInCartFun;
